<div class="gpd-full-page">
  <app-page-nav-bar [tabs]="headerTabs" [secondaryTabs]="projectSecondaryTabs.length ? projectSecondaryTabs : null"></app-page-nav-bar>
  <div class="gpd-inner-page" [ngClass]="{'gpd-inner-page--flush': isInnerPageFlush}">
    <router-outlet> </router-outlet>
  </div>
</div>
